export const APP_CONFIG = {
  logistics: process.env.REACT_APP_LOGISTICS,
  order: process.env.REACT_APP_ORDER,
  gateway: process.env.REACT_APP_GATEWAY,
  home: process.env.REACT_APP_HOME,
  user: process.env.REACT_APP_USER,
  occasion: 'https://dawa-be.azurewebsites.net/api/',
};
